import React from "react"
import PropTypes from "prop-types"
import { SEGMENTOS_ORDEN, segmentoConfig, formatNumber } from "./helpers"

/**
 * Chips horizontales con conteo por segmento. Click → filtra el catálogo.
 * "Todos" suma todos los segmentos.
 */
const ChipsSegmentos = ({ segmentosCount, total, segmentoActivo, onClickSegmento }) => {
  const counts = segmentosCount || {}
  // Solo mostrar segmentos que tengan al menos 1 cliente
  const segmentosConDatos = SEGMENTOS_ORDEN.filter(k => Number(counts[k]) > 0)

  return (
    <div style={{
      display: "flex", flexWrap: "wrap", gap: 8,
      padding: "12px 14px", background: "#f8fafc",
      borderRadius: 12, border: "1px solid #e2e8f0",
    }}>
      <ChipSegmento
        keyId="all"
        label="Todos"
        emoji="👥"
        count={total}
        color="#475569"
        bg="#e2e8f0"
        activo={!segmentoActivo}
        onClick={() => onClickSegmento("")}
      />
      {segmentosConDatos.map(k => {
        const cfg = segmentoConfig(k)
        return (
          <ChipSegmento
            key={k}
            keyId={k}
            label={cfg.label}
            emoji={cfg.emoji}
            count={counts[k]}
            color={cfg.color}
            bg={cfg.bg}
            activo={segmentoActivo === k}
            onClick={() => onClickSegmento(k)}
          />
        )
      })}
    </div>
  )
}

ChipsSegmentos.propTypes = {
  segmentosCount: PropTypes.object,
  total: PropTypes.number,
  segmentoActivo: PropTypes.string,
  onClickSegmento: PropTypes.func.isRequired,
}

const ChipSegmento = ({ label, emoji, count, color, bg, activo, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    title={`Filtrar por ${label}`}
    style={{
      border: activo ? `2px solid ${color}` : "1px solid transparent",
      background: activo ? "#fff" : bg,
      color, padding: activo ? "5px 12px" : "6px 13px",
      borderRadius: 999, fontSize: 12, fontWeight: 700,
      display: "inline-flex", alignItems: "center", gap: 6,
      cursor: "pointer",
      boxShadow: activo ? `0 2px 6px ${color}40` : "none",
      transition: "all 0.15s ease",
    }}
  >
    <span style={{ fontSize: 14 }}>{emoji}</span>
    <span>{label}</span>
    <span style={{
      background: activo ? color : `${color}30`,
      color: activo ? "#fff" : color,
      padding: "1px 8px", borderRadius: 999,
      fontSize: 11, fontWeight: 700,
    }}>
      {formatNumber(count || 0)}
    </span>
  </button>
)

ChipSegmento.propTypes = {
  keyId: PropTypes.string,
  label: PropTypes.string,
  emoji: PropTypes.string,
  count: PropTypes.number,
  color: PropTypes.string,
  bg: PropTypes.string,
  activo: PropTypes.bool,
  onClick: PropTypes.func,
}

export default ChipsSegmentos
